import { render, staticRenderFns } from "./VehicleCustomerManagement.vue?vue&type=template&id=f1edfc9a&scoped=true&"
import script from "./VehicleCustomerManagement.vue?vue&type=script&lang=js&"
export * from "./VehicleCustomerManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1edfc9a",
  null
  
)

export default component.exports